import { useContext } from 'react';
import { SnackbarContext } from '../snackbarContext/SnackbarContext';

const useSnackbar = () => useContext(SnackbarContext);

export default useSnackbar;